function ListOfCurrency() {
    return (
      <>
        <div className="font-bold text-lg mb-16">ListOfCurrency</div>
      </>
    );
  }
  
  export default ListOfCurrency;